var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "horizontal-menu-sticky",
      class: `has-hero-text-${_vm.$theme.name} ${`theme-${_vm.$theme.name}`}`,
    },
    [
      _c("div", { staticClass: "hero-body paddingless hanger" }, [
        _c(
          "div",
          { staticClass: "horizontal-menu-container" },
          [
            _c("module-sub-nav", {
              attrs: {
                "menu-items": _vm.visibleMenuItems,
                "menu-items-more": _vm.visibleMoreMenuItems,
              },
              on: {
                "item-click": _vm.handleItemClick,
                "custom-action": _vm.handleCustomAction,
              },
              scopedSlots: _vm._u([
                {
                  key: "menu-item-actions",
                  fn: function ({ item }) {
                    return [
                      item.label === "Images" && _vm.imageCount > 0
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: { enabled: true },
                                  expression: "{ enabled: true }",
                                },
                              ],
                              staticClass:
                                "icon breakout-icon-hover is-clickable",
                              attrs: { content: "Image Breakout" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.handleClickImageBreakOut.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "mso mso-16px" }, [
                                _vm._v("open_in_new"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }